import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap';
import {Subject} from 'rxjs/Subject';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {IOption} from 'ng-select';
import {ToastrService} from 'ngx-toastr';
import {ConfigLoyaltyService} from '../../integrate-loyalty/config-loyalty/services/config-loyalty.services';
import {ImageService} from '../../../../imageService';
import {PagerService} from '../../../../../common/services/Pagination.service';
import {Router} from '@angular/router';
import {debounce} from 'lodash';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;
@Component({
  selector: 'app-config-loyalty-stamp',
  templateUrl: './config-loyalty-stamp.component.html',
  styleUrls: ['./config-loyalty-stamp.component.css'],
  providers: [ConfigLoyaltyService]
})

export class ConfigLoyaltyStampComponent implements OnInit {

  @Output('hideCrating') hideCrating = new EventEmitter();
  @Input() detail: any = {};
  @Input() list_prods: any = [];
  @ViewChild('boxRetalStamps') boxRetalStamps;
  @ViewChild('campaign') campaign: ModalDirective;
  @ViewChild('scan') scan: ModalDirective;
  @ViewChild('confirm') confirm: ModalDirective;

  title = 'Gán chương trình loyalty';
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  addContent = '';
  listContent = [];
  unsubscribe$ = new Subject<void>();
  totalStatus;
  groupItems = [];
  waringListContent = '';
  stampList = [];
  errMess = [];
  warningMess = [];
  boxStampMess = '';
  boxStampMessWarring = '';
  loading = false;
  public user: any;

  formCratingBatch: FormGroup = this.fb.group({
    is_cratingStampsSingle: [true],
    is_cratingStampsList: [false],
    stampCode: ['', [Validators.required]],
    stampCodeList: this.fb.array([]),
    note: [null],
    service: [true],
  });
  isReadmore: Boolean = false;
  boxTypeList: Array<IOption> = [
    {
      value: '0',
      label: 'Box',
    },
    {
      value: '1',
      label: 'Planet',
    },
    {
      value: '2',
      label: 'Container',
    },
  ];


  // results$: Observable<any>
  constructor(
    private fb: FormBuilder,
    // private batchService: BatchService,
    private toastr: ToastrService,
    private configLoyaltyService: ConfigLoyaltyService,
    private imageService: ImageService,
    private pagerService: PagerService,
    private router: Router,
    private translate: TranslateService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
    this.searchCode = debounce(this.searchCode, 1000);
  }

  ngOnInit() {
    $('#crating_type').select2({
      placeholder: this.translate.instant('HINH_THUC_DONG_GOI_PLACEHOLDER'),
      allowClear: false,
      minimumResultsForSearch: -1,
    });

    this.translate.onLangChange.subscribe(() => {
      $('#crating_type').select2({
        placeholder: this.translate.instant('HINH_THUC_DONG_GOI_PLACEHOLDER'),
        allowClear: false,
        minimumResultsForSearch: -1,
      });
    });

    this.getListBoxType();
  }

  getListBoxType() {
    this.configLoyaltyService.listBoxType().subscribe(
      (res) => {
        if (res.code === 1) {
          this.boxTypeList = res.data.map((item) => {
            return {
              value: item.type,
              label: item.name,
            };
          });
        } else {
          this.boxTypeList = [];
        }
      },
      (err) => {
        this.boxTypeList = [];
        console.log(err);
      }
    );
  }

  timeout: any = null;
  checkboxSigle: false
  checkboxList: false
  firstTemp: string = ''
  lastTemp: string = ''

  changeCheckboxSigle() {
    this.checkboxSigle = $('#checkboxSigle').is(':checked')
    setTimeout(() => {
      $('#checkboxSigleVal').focus()
    }, 500)
  }

  changeCheckboxSigleValue() {

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.timeout = setTimeout(() => {
      console.log('asdfas', $('#checkboxSigleVal').val())

      let id = '';
      if ($('#checkboxSigleVal').val().search('http') !== -1) {
        const splitLink = $('#checkboxSigleVal').val().split('/')
        id = splitLink[splitLink.length - 1]
      } else {
        id = $('#checkboxSigleVal').val()
      }

      if (id) {
        console.log('id', id)

        this.configLoyaltyService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              this.loadDataChild([...this.listContent, ...val.data])
            } else {
              this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
            console.log('val', val)
          })
      } else {
        this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
      $('#checkboxSigleVal').val('')

    }, 200);
  }

  changeCheckboxList() {
    this.checkboxList = $('#checkboxList').is(':checked')
    setTimeout(() => {
      $('#checkboxListF').focus()
    }, 500)
  }

  changeCheckboxListValue(type) {

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.timeout = setTimeout(() => {
      // @ts-ignore
      let checkboxListVal: any;
      if (type === 'first') {
        checkboxListVal = $('#checkboxListF')

      } else {
        checkboxListVal = $('#checkboxListL')

      }
      console.log('asdfas', checkboxListVal.val())
      // const domain = [
      //   'http://dev-qcheck.icheck.vn/',
      //   'https://dev-qcheck.icheck.vn/',
      //   'http://qcheck-dev.vn/',
      //   'https://qcheck-dev.vn/'
      // ]
      let id = '';
      if (checkboxListVal.val().search('http') !== -1) {
        const splitLink = checkboxListVal.val().split('/')
        id = splitLink[splitLink.length - 1]
        // domain.map((res) => {
        //   if (checkboxListVal.val().search(res) !== -1) {
        //     id = checkboxListVal.val().replace(res, '');
        //   }
        // })
      } else {
        id = checkboxListVal.val()
      }

      if (id) {
        console.log('id', id)

        this.configLoyaltyService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              if (type === 'first') {
                this.firstTemp = val.data
                $('#checkboxListL').focus()
              } else {
                // clear all
                this.lastTemp = val.data
                if (this.firstTemp.split('-')[0] === this.lastTemp.split('-')[0]) {
                  // tslint:disable-next-line:max-line-length
                  this.codeList().push(this.newCodeListScan(this.firstTemp.split('-')[0], this.firstTemp.split('-')[1], this.lastTemp.split('-')[1]));
                  this.stampCodeChanged(this.formCratingBatch.value.stampCodeList.length - 1)
                  $('#checkboxListF').val('')
                  $('#checkboxListL').val('')
                  $('#checkboxListF').focus()

                } else {
                  this.toastr.warning('Serial cuối không hợp lệ', 'Cảnh báo', {
                    timeOut: 3000,
                    positionClass: 'toast-top-right',
                  });
                  $('#checkboxListL').val('')
                }
              }
              // this.loadDataChild([val.data])
            } else {
              this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
            console.log('val', val)
          })
      } else {
        this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }

    }, 200);
  }

  newCodeListScan(prefix, serialFirst, serialLast): FormGroup {
    return this.fb.group({
      prefix: prefix,
      serialFirst: serialFirst,
      serialLast: serialLast,
      data: [],
      mess: '',
    });
  }

  backToList(data = {}) {
    this.listContent = [];
    this.removeCodeListAll();
    this.formCratingBatch.get('stampCode').setValue('');
    this.hideCrating.emit(data);
  }

  changeReadMore(i, e) {
    // this.isReadmore = e;
    this.formCratingBatch.value.stampCodeList[i].isReadmore = e;
  }

  submitFormConfigConfirm(data_post: any) {
    this.loading = true;
    this.confirm.hide();
    console.log(12312312)
    setTimeout(() => {
      if (this.errMess.length > 0) {
        this.toastr.warning('Tem lẻ đang bị lỗi', 'Thông báo:', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      if (this.boxStampMess !== null) {
        if (this.boxStampMess.trim().length > 0) {
          this.toastr.warning('Mã tem thùng đang bị lỗi', 'Thông báo:', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          return;
        }
      }
      if (
        this.formCratingBatch.value.is_cratingStampsSingle === false &&
        this.formCratingBatch.value.is_cratingStampsList === false
      ) {
        this.toastr.warning(
          'Bạn phải chọn ít nhất 1 phương thức đóng thùng',
          'Thông báo:',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          }
        );
        return;
      }
      let checkStampCodeList = 0;
      const dataStampList = [];

      data_post.stampCodeList.map((res) => {
        dataStampList.push({
          prefix: res.prefix.toUpperCase(),
          idStart: res.serialFirst,
          idEnd: res.serialLast,
        });
      });

      if (this.stampList != undefined && dataStampList.length > 0) {
        for (let i = 0; i < this.stampList.length; i++) {
          dataStampList.push(this.stampList[i]);
        }
      }
      if (checkStampCodeList > 0) {
        this.confirm.hide();
        this.toastr.warning('Tem dải đang bị lỗi', 'Thông báo:', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      let body = {};
      console.log('scan1', this.applyScan, ' piri1', this.priority);
      if (this.listContent.length > 0 && dataStampList.length <= 0) {
        body = {
          stampGroups: this.stampList,
          productIds: null,
          agencyIds: null,
          campaignId: Number(this.myCampaign[0]),
          campaignCode: this.campaignCode,
          campaignType: this.campaignCode ? 1 : 0,
          giftCode: this.giftCode,
          priority: this.priority,
          applyScan: this.applyScan === null ? '' : Number(this.applyScan),
          systemType: 1
        };
        console.log('bodysss 1 ', body)
      } else if (this.listContent.length <= 0 && dataStampList.length > 0) {
        body = {
          stampGroups: dataStampList,
          productIds: null,
          agencyIds: null,
          campaignId: Number(this.myCampaign[0]),
          campaignCode: this.campaignCode,
          campaignType: this.campaignCode ? 1 : 0,
          giftCode: this.giftCode,
          priority: this.priority,
          applyScan: Number(this.applyScan),
          systemType: 1
        };
      } else if (this.listContent.length <= 0 && dataStampList.length <= 0) {
        this.loading = false;
        this.toastr.warning('Bạn chưa nhập Tem lẻ hoặc Dải tem', 'Thông báo:', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        console.log('this.lo0adindasd', this.loading)
        return;

      } else {
        body = {
          stampGroups: dataStampList,
          productIds: null,
          agencyIds: null,
          campaignId: Number(this.myCampaign[0]),
          campaignCode: this.campaignCode,
          campaignType: this.campaignCode ? 1 : 0,
          giftCode: this.giftCode,
          priority: this.priority,
          applyScan: Number(this.applyScan),
          systemType: 1
        };
        console.log('bodysss 3 ', body)
      }

      /**Validate khi submit */
      let errMessLoyalty = [];
      let notfi = '';
      let allItem = [];
      this.configLoyaltyService.validateStampLoyalty(body).subscribe(
        (res) => {
          if (res.code == 1) {
            allItem = res.data.items.map((val) => {
              return val;
            })
            if (allItem.length == res.data.pagination.totalElements) {
              allItem.map((val) => {
                if (val.errMessage !== null) {
                  let mess = '';
                  if (val.idStart === val.idEnd) {
                    mess = this.formatSerial(val.idStart, val.prefix.toUpperCase()) + ' : ' + val.errMessage;
                  } else {
                    mess = this.formatSerial(val.idStart, val.prefix.toUpperCase())
                      + ' -> ' + this.formatSerial(val.idEnd, val.prefix.toUpperCase())
                      + ' : ' + val.errMessage;
                  }
                  errMessLoyalty.push(mess);
                }
              });
            }
            console.log(errMessLoyalty)
            if (errMessLoyalty.length > 0) {
              this.loading = false
              this.toastr.error(errMessLoyalty.join(`<br>`), `Gán chương trình loyalty thất bại`, {
                timeOut: 10000,
                enableHtml: true,
                positionClass: 'toast-top-right'
              })
            } else {
              this.configLoyaltyService.configLoyalty(body).subscribe(
                (res) => {
                  if (res.code === 1) {
                    if (res.data !== null && res.data.acceptBoxed === false) {
                      this.toastr.warning(res.data.msg, 'Thông báo:', {
                        timeOut: 3000,
                        positionClass: 'toast-top-right',
                      });
                      return;
                    }
                    this.errMess = [];
                    this.warningMess = [];
                    this.boxStampMessWarring = '';
                    this.listContent = [];
                    this.giftCode = null;
                    this.campaignCode = null;
                    this.isCampaign = false;
                    this.removeCodeListAll();
                    this.formCratingBatch.get('stampCode').setValue('');
                    this.formCratingBatch.get('note').setValue('');
                    $('#crating_type').val('').trigger('change');
                    this.loading = false
                    this.confirm.hide();
                    this.toastr.success('Gán chương trình loyalty thành công: ' + 'Thành công:' + res.data.success + ' Thất bại: ' + res.data.fail, 'Thông báo:', {
                      timeOut: 3000,
                      positionClass: 'toast-top-right',
                    });
                    this.backToList({isBack: false})
                  } else {
                    this.loading = false
                    this.confirm.hide();
                    this.toastr.warning(res.message, 'Thông báo:', {
                      timeOut: 3000,
                      positionClass: 'toast-top-right',
                    });
                  }
                },
                (err) => {
                  this.loading = false
                  this.confirm.hide();
                  this.toastr.warning(err.message, 'Thông báo:', {
                    timeOut: 3000,
                    positionClass: 'toast-top-right',
                  });

                }
              );
            }
          } else {
            this.loading = false
            console.log('vao day ko ')
            this.toastr.warning(res.message, 'Thông báo:', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }
        }, (err) => {
          this.loading = false
          console.log(err);
          this.toastr.error('Có lối xảy ra', 'Thông báo:', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });

        }
      );

    }, 1000);
  }

  cratingStampsChange() {
    if (this.formCratingBatch.value.is_cratingStampsSingle === false) {
      this.listContent = [];
      this.checkboxSigle = false
    }
    if (this.formCratingBatch.value.is_cratingStampsList === false) {
      this.removeCodeListAll();
      this.checkboxList = false
    }
  }

  // boxRetalStamps
  removeItem(index) {
    console.log('ákfhaskdhasdasds')
    this.listContent = this.listContent.filter((res, i) => i !== index);
    this.stampList = this.stampList.filter((res, i) => i !== index);
    this.checkStampValidate();
  }

  showModal() {
    const data = {
      id: 'myModalCrating',
      title: 'THÊM DANH SÁCH TEM LẺ',
      contentMess: 'Bạn chưa nhập team lẻ',
      listContent: this.listContent,
    };
    this.boxRetalStamps.show(data);
  }

  public stampSingle: Object;

  loadDataChild(e) {
    console.log('this.listContent', this.listContent.toString());
    const stampList = [];
    e.map((res) => {
      let splitSerial = res.split('-');
      let _serial: any = '';
      let _prefix: any = '';
      if (splitSerial.length > 1) {
        _serial = splitSerial.pop();
        _prefix = splitSerial[0];
        console.log(_serial, _prefix);
      } else {
        _serial = NaN;
        _prefix = splitSerial[0];
      }
      const stamp = {
        prefix: _prefix,
        idStart: _serial,
        idEnd: _serial,
      };
      this.stampSingle = stamp;
      stampList.push(stamp);
    });
    this.stampList = stampList;

    // this.checktemp();
    // console.log(stampList)
    this.listContent = e;
    this.checkStampValidate();
  }

  formatSerial(id: any, prefix: string) {
    let serial_f = '';
    id = id.toString();
    if (id && prefix) {
      const pad = '000000';
      const serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + '-' + serial;
    }
    return serial_f;
  }

  checkStampValidate() {
    console.log(23434)
    this.errMess = ['Đang kiểm tra...'];
    const query = {
      stampGroups: this.stampList,
      systemType: 1,
      campaignId: null,
      campaignCode: null,
    };
    const errMess = [];
    let allItem = [];
    if (this.listContent.length > 0) {
      this.configLoyaltyService.validateStampLoyalty(query).subscribe(
        (res) => {
          if (res.code == 1) {
            allItem = res.data.items.map((val) => {
              return val;
            })
            if (allItem.length == res.data.pagination.totalElements) {
              allItem.map((val) => {
                if (val.errMessage !== null) {
                  let mess = '';
                  if (val.idStart === val.idEnd) {
                    mess = this.formatSerial(val.idStart, val.prefix.toUpperCase()) + ' : ' + val.errMessage;
                  } else {
                    mess = this.formatSerial(val.idStart, val.prefix.toUpperCase())
                      + ' -> ' + this.formatSerial(val.idEnd, val.prefix.toUpperCase())
                      + ' : ' + val.errMessage;
                  }
                  errMess.push(mess);
                }
              });
            }
            console.log('mess' + errMess)
            if (errMess.length > 0) {
              this.errMess = errMess;
            } else {
              this.errMess = [];
            }
          } else {
            console.log('vao day ko ')
            this.errMess = [res.message]
          }
        }, (err) => {
          console.log(err);
          if (err && err.message) {
            this.errMess = [];
            this.errMess.push(err.message)
          } else {
            this.errMess = ['Đã có lỗi xảy ra']
          }
          this.warningMess = [];
        }
      );
    } else {
      this.errMess = [];
    }
  }

  isNaN(x) {
    // Ép kiểu Number cho biến x
    x = Number(x);
    // Nếu x là NaN, NaN != NaN trả về true, các trường hợp khác sẽ trả về false
    return x != x;
  }

  codeList(): FormArray {
    return this.formCratingBatch.get('stampCodeList') as FormArray;
  }

  newCodeList(): FormGroup {
    return this.fb.group({
      prefix: '',
      serialFirst: '',
      serialLast: '',
      data: null,
      title: '',
      isReadmore: false,
    });
  }

  addCodeList() {
    // console.log(this.formCratingBatch.value);
    this.codeList().push(this.newCodeList());
  }

  removeCodeList(i: number) {
    this.codeList().removeAt(i);
    // this.checktemp();
  }

  removeCodeListAll() {
    while (this.codeList().length !== 0) {
      this.codeList().removeAt(0);
    }
  }

  stampCodeChanged(i) {
    if (
      this.formCratingBatch.value.stampCodeList[i].prefix.trim() !== '' &&
      this.formCratingBatch.value.stampCodeList[i].serialFirst.trim() !== '' &&
      this.formCratingBatch.value.stampCodeList[i].serialLast.trim() !== ''
    ) {
      this.formCratingBatch.value.stampCodeList[i].title = 'Đang kiểm tra...';

      // tslint:disable-next-line:radix max-line-length
      if (
        parseInt(
          this.formCratingBatch.value.stampCodeList[i].serialFirst.trim()
        ) >
        parseInt(this.formCratingBatch.value.stampCodeList[i].serialLast.trim())
      ) {
        console.log(1111);
        this.formCratingBatch.value.stampCodeList[i].title =
          'Serial cuối phải lớn hơn Serial đầu';
      } else {
        // this.checktemp();
        console.log('goi API', i);
        const query = {
          stampGroups: [{
            prefix: this.formCratingBatch.value.stampCodeList[i].prefix.trim().toUpperCase(),
            idStart: this.formCratingBatch.value.stampCodeList[i].serialFirst.trim(),
            idEnd: this.formCratingBatch.value.stampCodeList[i].serialLast.trim(),
          }],
          systemType: 1
          // type: 2,
          // prefix: this.formCratingBatch.value.stampCodeList[i].prefix
          //   .trim()
          //   .toUpperCase(),
          // start: this.formCratingBatch.value.stampCodeList[
          //   i
          // ].serialFirst.trim(),
          // end: this.formCratingBatch.value.stampCodeList[i].serialLast.trim(),
        };
        // @ts-ignore
        this.configLoyaltyService.validateStampLoyalty(query).subscribe(
          (res) => {
            console.log('configLoyaltyService', res);
            if (res.code === 1) {
              if (res.data.length === 0) {
                this.formCratingBatch.value.stampCodeList[i].data = null;
                // this.formCratingBatch.value.stampCodeList[i].warning = ''
                // this.formCratingBatch.value.stampCodeList[i].mess = ''
              } else {
                this.formCratingBatch.value.stampCodeList[i].title =
                  res.data.items[0].errMessage;
                this.formCratingBatch.value.stampCodeList[i].data = res.data.items[0];

                // if (res.data[0].acceptBoxed === false) {
                //   this.formCratingBatch.value.stampCodeList[i].mess = res.data[0].msg
                //   this.formCratingBatch.value.stampCodeList[i].warning = ''
                // } else {
                //   this.formCratingBatch.value.stampCodeList[i].warning = res.data[0].msg
                //   this.formCratingBatch.value.stampCodeList[i].mess = ''
                // }
              }
            } else {
              this.formCratingBatch.value.stampCodeList[i].title = res.message;
              this.formCratingBatch.value.stampCodeList[i].data = null;
              //
              // this.formCratingBatch.value.stampCodeList[i].mess = res.message
              // this.formCratingBatch.value.stampCodeList[i].warning = ''
            }
            console.log(this.formCratingBatch.value.stampCodeList[i]);
          },
          (err) => {
            this.formCratingBatch.value.stampCodeList[i].title =
              'Đã có lỗi sảy ra';
            // this.formCratingBatch.value.stampCodeList[i].warning = ''
          }
        );
      }
    }
  }

  checkTripNumber(item, itemFirst, itemLast) {
    // console.log(item, itemFirst, itemLast, itemFirst <= item && item <= itemLast)
    return itemFirst <= item && item <= itemLast;
  }

  // end codeList

  searchCode() {
    this.boxStampMess = 'Đang kiểm tra...';
    let query: any = null;
    if (
      this.formCratingBatch.value.stampCode &&
      this.formCratingBatch.value.stampCode.trim()
    ) {
      query = {
        box_stamp: this.formCratingBatch.value.stampCode.trim().toUpperCase(),
      };
    }
    // console.log(1111, query);
    if (this.formCratingBatch.value.stampCode.length > 0 && query) {
      this.configLoyaltyService.boxValidate(query).subscribe(
        (res) => {
          // console.log('res', res)
          if (res.code === 1) {
            if (res.data !== null && res.data.acceptBoxed === false) {
              this.boxStampMess = res.data.msg;
              this.boxStampMessWarring = '';

              return;
            }

            if (res.data !== null && res.data.acceptBoxed === true) {
              this.boxStampMessWarring = res.data.msg;
              this.boxStampMess = '';

              return;
            }
            this.boxStampMess = '';
            this.boxStampMessWarring = '';
          } else {
            this.boxStampMess = res.message;
            this.boxStampMessWarring = '';
          }
        },
        (err) => {
          this.boxStampMess =
            err && err.message ? err.message : 'Đã có lỗi xảy ra';
          this.boxStampMessWarring = '';
        }
      );
    } else {
      this.boxStampMess = '';
      this.boxStampMessWarring = '';
    }
  }

  // Cấu hình chiến dịch sell-out
  campaignChange() {
    console.log(123);
  }

  data_campaign = []
  has_data_campaign: boolean = true;
  errorMessage: string = '';
  public pager: any;
  public pageIndex: number = 1;
  public page_size: number = 6;
  public totalRow: number = 0;
  public total_data_campaign: number = 0
  listOfChecked: string = '';
  list_id = [];
  checkSelectCampain: number = 0;
  myCampaign = {}
  isCampaign = false;
  public campaignCode: string;
  public giftCode: string;
  public changeService: Boolean = false;
  public changeIdetification: Boolean = false;
  public changeOverflow: Boolean = false;
  public applyScan: any = null;
  public priority: number = 0;

  loadCampaign() {
    this.campaign.show();
    let query = {
      page: this.pageIndex,
      pageSize: this.page_size,
      systemType: 1
    }
    this.configLoyaltyService.getListCampaignLoyalty(query).subscribe(
      (res) => {
        if (res.code === 1) {
          this.total_data_campaign = res.data.pagination.totalElements;
          let list: any = [];
          for (let _data of res.data.items) {
            let obj = {
              id: _data.id,
              name: _data.name,
              image: this.imageService.readSrcImage(_data.image, 'thumb_large'),
              status: _data.status,
              idEnd: _data.idEnd,
              statusTitle: _data.statusTitle,
              start: _data.start,
              end: _data.end,
              approved: _data.approved,
            };
            list.push(obj);
          }
          ;
          this.data_campaign = list
          console.log(this.has_data_campaign);
          if (list.length > 0) {
            this.has_data_campaign = true;
          } else {
            this.has_data_campaign = false;
          }
        } else {
          this.errorMessage = res.message;
        }
        (err) => {
          console.log(err)
        }
      }
    )
  }

  prePageList() {
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      // this.loading_left = true;
      this.loadCampaign();
    }
  }

  lastPageList() {
    // console.log('res.items', this.pageIndex * this.page_size, this.total_data )
    // if (this.pageIndex * this.page_size < this.total_data) {
    this.pageIndex = this.pageIndex + 1;
    // this.loading_left = true;
    this.loadCampaign();
    // }
  }

  inputPageList(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex = page;
      // this.loading_left = true;
      this.loadCampaign();
    }
  }


  onchange() {
    console.log('checkbox');
  }

  onMyCampaign() {
    this.checkSelectCampain = 1;
    this.campaignCode = null
  }

  onOtherCampaign() {
    this.checkSelectCampain = 2;
    this.isCampaign = false
    this.myCampaign = {}
  }

  radioBoxChange(event) {
    this.listOfChecked = event.target.value;
    console.log('tuanba: ' + this.listOfChecked);
  }

  confirmCampaign() {
    this.myCampaign = this.listOfChecked.split(',');
    this.isCampaign = true;
    this.campaign.hide();
    this.pageIndex = 1;
    console.log(typeof (this.myCampaign));
  }

  onChangeService() {
    this.changeService = true;
    this.changeIdetification = false
    this.priority = 1;
    this.applyScan = 0;
  }

  radioBoxChangeService(event) {
    this.applyScan = event.target.value;
  }

  onChangeGuarantee() {
    this.scan.show();
    this.changeService = false;
    this.changeIdetification = false;
    this.changeOverflow = false;
    this.priority = 0;
    this.applyScan = null;
    console.log('scan', this.applyScan, ' piri', this.priority);
  }

  onChangeIdentification() {
    this.changeIdetification = true;
    this.changeService = false;
    this.changeOverflow = false;
    this.priority = 5;
    this.applyScan = 0;
  }

  radioBoxChangeIdentification(event) {
    this.applyScan = event.target.value;
  }

  onChangeOverflow() {
    this.changeIdetification = false;
    this.changeService = false;
    this.changeOverflow = true;
    this.priority = 3;
    this.applyScan = 0;

  }

  radioBoxChangeOverflow(event) {
    this.applyScan = event.target.value;
  }

  confirmGuarantee() {
    this.priority = 2;
    this.applyScan = null;
    this.scan.hide();
    console.log('scan', this.applyScan, ' piri', this.priority);
  }

  closeGuarantee() {
    this.priority = 0;
    this.applyScan = null;
    this.scan.hide();
    $('input[name="scan"]').attr('checked', false);
  }

  confimLoyalty() {
    this.confirm.show()
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/integrate-loyalty-v2/config-loyalty-stamp/config-loyalty-stamp.component.ts